// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-slider-container {
    margin-top: 10px;
    margin-left: 5px;
    width: 260px;
    z-index: 10;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);
    background: linear-gradient(to top, #eaeaea, #f3f3f3);
    display: flex;
    flex-direction: column;
}

.grid-slider-container div {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

@media (min-width: 145rem) {
    .grid-slider-container div {
        flex-direction: row;
        justify-content: space-between;
    }
}

.grid-slider-container label {
    margin-bottom: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.grid-slider-container div input[type="range"] {
    width: 100%;
    margin-top: 10px;
    -webkit-appearance: none;
    height: 6px;
    background: #c4c4c4;
    outline: none;
    border-radius: 3px;
    transition: background 0.15s ease-in-out;
}

.grid-slider-container div input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 16px;
    height: 16px;
    background: #afb4c4;
    border-radius: 50%;
    cursor: pointer;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
}

.grid-slider-container div input[type="range"]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: #808cab;
    border-radius: 50%;
    cursor: pointer;
}

.grid-slider-container div input[type="range"]:hover::-webkit-slider-thumb {
    background: #808cab;
}

.grid-slider-container h4 {
    margin-top: 10px;
    color: #333;
}

.grid-slider-container div label {
    font-size: 12px;
    margin: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/GridSetting.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,qDAAqD;IACrD,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,8BAA8B;IAClC;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,wCAAgC;IAAhC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;AACjB","sourcesContent":[".grid-slider-container {\n    margin-top: 10px;\n    margin-left: 5px;\n    width: 260px;\n    z-index: 10;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);\n    background: linear-gradient(to top, #eaeaea, #f3f3f3);\n    display: flex;\n    flex-direction: column;\n}\n\n.grid-slider-container div {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n}\n\n@media (min-width: 145rem) {\n    .grid-slider-container div {\n        flex-direction: row;\n        justify-content: space-between;\n    }\n}\n\n.grid-slider-container label {\n    margin-bottom: 10px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n}\n\n.grid-slider-container div input[type=\"range\"] {\n    width: 100%;\n    margin-top: 10px;\n    -webkit-appearance: none;\n    height: 6px;\n    background: #c4c4c4;\n    outline: none;\n    border-radius: 3px;\n    transition: background 0.15s ease-in-out;\n}\n\n.grid-slider-container div input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #afb4c4;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n.grid-slider-container div input[type=\"range\"]::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: #808cab;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.grid-slider-container div input[type=\"range\"]:hover::-webkit-slider-thumb {\n    background: #808cab;\n}\n\n.grid-slider-container h4 {\n    margin-top: 10px;\n    color: #333;\n}\n\n.grid-slider-container div label {\n    font-size: 12px;\n    margin: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
